var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from "react";
import { Container, Grid, Typography } from "@mui/material";
import CrudTable from "../../CrudTable";
import { getTrials, createTrial, updateTrial, deleteTrial, } from "../../../utils/api/trials/dataAccess";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../../modal/ConfirmationModal";
//Sites for dropdown
import { getSites } from "../../../utils/api/sites/dataAccess";
//Species for dropdown
import { getSpecies } from "../../../utils/api/species/dataAccess";
import Loader from "../../Loader";
const initialTrial = {
    id: "00000000-0000-0000-0000-000000000000",
    name: "Test Trial",
    trialCode: "Gh12345",
    siteName: null,
    latitude: null,
    longitude: null,
    url: null,
    trialYear: null,
    startDate: null,
    endDate: null,
    trialWarning: null,
    trialDocument: null,
    regionName: null,
    speciesName: "Italian Ryegrass",
    annualRainfall: null,
    soilTypeName: null,
    soilTypeDescription: null,
    varieties: "",
    irrigated: false,
    trialVarieties: [],
    highlightedTrial: false,
    siteId: null, //"BE00E96F-2715-4E40-B9F3-FA25AC8BBDE7",
    speciesId: null, //"9E1F3266-34B4-4CB4-85F3-FE44A8D1B234",
};
const AdminTrialControl = () => {
    const navigate = useNavigate();
    const [trials, setTrials] = useState([]);
    const [loading, setLoading] = useState(true);
    const [confirmationMessage, setConfirmationMessage] = useState("");
    //Site Data for dropdowns
    const [site, setSite] = useState([]);
    //Species Data for dropdowns
    const [species, setSpecies] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [trialForUpdate, setTrialForUpdate] = useState(initialTrial);
    //similar to Results.tsx, this useEffect will fetch the trials from the indexedDB
    useEffect(() => {
        const fetchTrials = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                //-----------------------------------------------------------------------------------
                //                            TRIAL DATA
                //-----------------------------------------------------------------------------------
                const apiResponse = yield getTrials(true);
                //unauthorised
                if (apiResponse.status === 401) {
                    navigate("/not-authorized");
                    return;
                }
                setTrials(apiResponse.data);
                //-----------------------------------------------------------------------------------
                //                      SITE DATA FOR DROPDOWNS
                //-----------------------------------------------------------------------------------
                const siteResponse = yield getSites(true); //includeArchived
                //transform to DefaultDropdownType
                const siteDropdownData = siteResponse.data.map((site) => {
                    return { name: site.name, value: site.id };
                });
                setSite(siteDropdownData);
                //-----------------------------------------------------------------------------------
                //                      SPECIES DATA FOR DROPDOWNS
                //-----------------------------------------------------------------------------------
                const speciesResponse = yield getSpecies();
                //transform to DefaultDropdownType
                const speciesDropdownData = speciesResponse.data.map((species) => {
                    return { name: species.name, value: species.id };
                });
                setSpecies(speciesDropdownData);
            }
            catch (error) {
                console.error("Error fetching trial data", error);
            }
            finally {
                setLoading(false);
            }
        });
        fetchTrials();
    }, [navigate]);
    if (loading) {
        return React.createElement(Loader, null);
    }
    const handleAddTrial = (trial) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            let apiResponse = yield createTrial(trial);
            //unauthorised
            if (apiResponse.status === 401) {
                navigate("/not-authorized");
                return null;
            }
            if (apiResponse.status === 200 && apiResponse.data.length > 0) {
                setTrials([...trials, apiResponse.data[0]]);
                alert("Trial has been added: with Trial Code: " + apiResponse.data[0].trialCode);
                return null;
            }
            else {
                return apiResponse.message || "Error adding trial. Please check all required fields.";
            }
        }
        catch (error) {
            console.error("Error adding Trial:", error);
            return "An unexpected error occurred while adding the trial.";
        }
    });
    const handleEditTrial = (updatedTrial) => __awaiter(void 0, void 0, void 0, function* () {
        setConfirmationMessage("Are you sure?");
        setTrialForUpdate(updatedTrial);
        setIsOpen(true);
    });
    const handleDeleteTrial = (trialToDelete) => __awaiter(void 0, void 0, void 0, function* () {
        // Delete trial from IndexedDB and API
        try {
            var apiResponse = yield deleteTrial(trialToDelete);
            if (apiResponse.status === 401) {
                navigate("/not-authorized");
                return;
            }
            if (apiResponse.status === 200) {
                const updatedTrials = trials.filter((trial) => trial.id !== trialToDelete.id);
                setTrials(updatedTrials);
            }
        }
        catch (error) {
            console.error("Error deleting Trial:", error);
        }
    });
    const handleConfirmationCancel = () => {
        setIsOpen(false);
        setTrialForUpdate(initialTrial);
    };
    //-----------------------------------------------------------------------------------
    //                      UPDATE TRIAL
    //-----------------------------------------------------------------------------------
    const handleConfirmationConfirm = () => __awaiter(void 0, void 0, void 0, function* () {
        if (trialForUpdate && trialForUpdate.id !== "000000000-0000-0000-0000-000000000000") {
            try {
                var apiResponse = yield updateTrial(trialForUpdate);
                if (apiResponse.status === 401) {
                    navigate("/not-authorized");
                    return;
                }
                if (apiResponse.status === 200) {
                    const updatedTrials = trials.map((trial) => {
                        if (trial.id === trialForUpdate.id) {
                            return trialForUpdate;
                        }
                        return trial;
                    });
                    setTrials(updatedTrials);
                    setIsOpen(false);
                    setTrialForUpdate(initialTrial);
                }
            }
            catch (error) {
                console.error("Error updating Trial:", error);
            }
        }
    });
    return (React.createElement(Container, { maxWidth: false, sx: { width: "100%" } },
        React.createElement(ConfirmationModal, { confirmationTitle: "Confirm Trial Changes", confirmationMessage: confirmationMessage, isOpen: isOpen, OnCancel: handleConfirmationCancel, OnConfirm: handleConfirmationConfirm }),
        React.createElement(Grid, { container: true, spacing: 2 },
            React.createElement(Grid, { item: true, xs: 12 },
                React.createElement(Typography, { variant: "h4" }, "Trial Administration"),
                React.createElement("p", null, "Archiving the trial will cause the trial to not be shown"),
                React.createElement(CrudTable, { data: trials, columns: [
                        {
                            field: "name",
                            headerName: "Name",
                            width: "350px",
                            required: true,
                        },
                        {
                            field: "trialCode",
                            headerName: "Trial Code",
                            columnReadOnly: true,
                            width: "100px",
                        },
                        {
                            field: "speciesId",
                            headerName: "Species",
                            optionalColumnData: species,
                            type: "dropdown",
                            required: true,
                        },
                        { field: "trialYear", headerName: "Year Sown", width: "150px", type: "number", required: true },
                        { field: "startDate", headerName: "Start", type: "date", width: "160px", },
                        { field: "endDate", headerName: "End", type: "date", width: "160px", },
                        { field: "trialWarning", headerName: "Warning", width: "150px", },
                        //site dropdown
                        {
                            field: "siteId",
                            headerName: "Site",
                            optionalColumnData: site,
                            type: "dropdown",
                            width: "150px",
                            required: true,
                        },
                        // checkbox for HighLightedTrial
                        {
                            field: "highlightedTrial",
                            headerName: "High-lighted",
                            type: "boolean",
                        },
                        { field: "irrigated", headerName: "Irrigated", type: "boolean" },
                        { field: "annualRainfall", headerName: "Annual Rainfall", type: "number", width: "150px", },
                        { field: "latitude", headerName: "Latitude", type: "number", width: "150px", },
                        { field: "longitude", headerName: "Longitude", type: "number", width: "150px", },
                        // checkbox for IsArchived
                        { field: "isArchived", headerName: "Archived", type: "boolean" },
                    ], onAdd: handleAddTrial, onEdit: handleEditTrial, onDelete: handleDeleteTrial, initialItem: initialTrial, showAddNew: true, showSearch: true, extraSearchFields: ["speciesName", "siteName"] })))));
};
export default AdminTrialControl;
